import './search.scss';

import SearchIcon from '@/shared/assets/icons/search.svg?react';

type SearchProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export function Search({ value, onChange, placeholder = '' }: SearchProps) {
  return (
    <div className="search">
      <SearchIcon className="search__icon" />
      <input
        className="search__input"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value.trim().length > 0 && (
        <button className="search__clear" onClick={() => onChange('')}>
          ✕
        </button>
      )}
    </div>
  );
}
